import { put, call, takeLatest, takeEvery } from "redux-saga/effects";
import { flashMessage } from "redux-flash";
import axios from "axios";
import {
  GET_PLANNINGS_REQUEST,
  getPlanningsSuccess,
  getPlanningsError,
  ADD_PLANNING_REQUEST,
  addPlanningSuccess,
  addPlanningError,
  UPDATE_PLANNING_REQUEST,
  updatePlanningSuccess,
  updatePlanningError,
  DELETE_PLANNING_REQUEST,
  deletePlanningSuccess,
  deletePlanningError,
} from "./actions";
import { logoutRequest } from "../login/actions";

import { createCalendarDates } from "./planningUtils";
import { Env } from "../../env";

function* getPlanningsRequest(action) {
  const { accessToken, userId } = action;
  let response;

  try {
    response = yield call(
      axios.get,
      `${Env.BASE_API_URL}/Accounts/${userId}/Plannings`,
      {
        headers: { Authorization: accessToken },
      }
    );
  } catch (err) {
    if (err.response && err.response.status === 401) {
      yield put(logoutRequest());
    } else {
      yield put(
        getPlanningsError("Une erreur s'est produite, veuillez réessayer.")
      );
      yield put(flashMessage("Une erreur s'est produite, veuillez réessayer."));
    }

    return;
  }

  const plannings = response.data.map((planning) => {
    const { start, end } = createCalendarDates(planning);

    return { ...planning, start, end };
  });

  yield put(getPlanningsSuccess(plannings));
}

export function* watchGetPlanningsRequest() {
  yield takeLatest(GET_PLANNINGS_REQUEST, getPlanningsRequest);
}

function* addPlanningRequest(action) {
  const { userId, accessToken, planning } = action;
  let response;

  const { start, end, title, playlistId } = planning;

  const dayOfWeek = start.getDay();
  const hourStart = start.getHours();
  const hourEnd = end.getMinutes() === 59 ? 20 : end.getHours();

  try {
    response = yield call(
      axios.post,
      `${Env.BASE_API_URL}/Accounts/${userId}/Plannings`,
      {
        dayOfWeek,
        hourStart,
        hourEnd,
        title,
        playlistId,
      },
      {
        headers: { Authorization: accessToken },
      }
    );
  } catch (err) {
    if (err.response && err.response.status === 400) {
      yield put(addPlanningError(planning));
      yield put(flashMessage("Erreur, veuillez vérifier vos informations."));
    } else if (err.response && err.response.status === 401) {
      yield put(logoutRequest());
    } else {
      yield put(addPlanningError(planning));
      yield put(flashMessage("Une erreur s'est produite, veuillez réessayer."));
    }

    return;
  }

  const planningApi = response.data;

  yield put(
    addPlanningSuccess(
      { ...planningApi, ...createCalendarDates(planningApi) },
      action.planning.tempId
    )
  );

  yield put(flashMessage("Nouveau planning créé avec succès."));
}

export function* watchAddPlanningRequest() {
  yield takeEvery(ADD_PLANNING_REQUEST, addPlanningRequest);
}

function* updatePlanningRequest(action) {
  const { userId, accessToken, planning } = action;
  let response;

  const { start, end, title, playlistId, id } = planning;

  const dayOfWeek = start.getDay();
  const hourStart = start.getHours();
  const hourEnd = end.getMinutes() === 59 ? 19 : end.getHours();

  try {
    response = yield call(
      axios.put,
      `${Env.BASE_API_URL}/Accounts/${userId}/Plannings/${id}`,
      {
        dayOfWeek,
        hourStart,
        hourEnd,
        title,
        playlistId,
      },
      {
        headers: { Authorization: accessToken },
      }
    );
  } catch (err) {
    if (err.response && err.response.status === 400) {
      yield put(updatePlanningError(planning));
      yield put(flashMessage("Erreur, veuillez vérifier vos informations."));
    } else if (err.response && err.response.status === 404) {
      yield put(updatePlanningError(planning));
      yield put(flashMessage("Erreur, ce planning n'existe pas."));
    } else if (err.response && err.response.status === 401) {
      yield put(logoutRequest());
    } else {
      yield put(updatePlanningError(planning));
      yield put(flashMessage("Une erreur s'est produite, veuillez réessayer."));
    }

    return;
  }

  const planningApi = response.data;

  yield put(
    updatePlanningSuccess({
      ...planningApi,
      ...createCalendarDates(planningApi),
    })
  );

  yield put(flashMessage("Planning éditée avec succès."));
}

export function* watchUpdatePlanningRequest() {
  yield takeEvery(UPDATE_PLANNING_REQUEST, updatePlanningRequest);
}

function* deletePlanningRequest(action) {
  const { userId, accessToken, planning } = action;

  // Delete local planning
  if (!planning.id) {
    yield put(deletePlanningSuccess(planning));
    yield put(flashMessage("Planning supprimé avec succès."));

    return;
  }

  try {
    yield call(
      axios.delete,
      `${Env.BASE_API_URL}/Accounts/${userId}/Plannings/${planning.id}`,
      {
        headers: { Authorization: accessToken },
      }
    );
  } catch (err) {
    if (err.response && err.response.status === 401) {
      yield put(logoutRequest());
    } else {
      yield put(deletePlanningError(planning));
      yield put(flashMessage("Une erreur s'est produite, veuillez réessayer."));
    }

    return;
  }

  yield put(deletePlanningSuccess(planning));

  yield put(flashMessage("Planning supprimé avec succès."));
}

export function* watchDeletePlanningRequest() {
  yield takeEvery(DELETE_PLANNING_REQUEST, deletePlanningRequest);
}



// WEBPACK FOOTER //
// ./src/pages/plannings/sagas.js